var _defs, _rect, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _line, _path28, _circle, _line2, _path29, _circle2, _path30, _circle3, _line3, _line4, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBvm1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 418.96 452.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d5ddeb;}.cls-2{fill:#812990;}.cls-3{fill:#fff;}.cls-4{fill:#231f20;}.cls-5{fill:#6b7b84;}.cls-6,.cls-7{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-7{stroke-dasharray:2 2;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.2,
    y: 33.62,
    width: 368.5,
    height: 368.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "289.73 402.12 68.63 402.12 179.18 217.87 400.28 217.87 289.73 402.12"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "289.73 33.62 179.18 217.87 68.63 33.62 289.73 33.62"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "50.2 33.62 68.63 33.62 179.18 217.87 68.63 402.12 50.2 402.12 50.2 33.62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.93,204.5h-.77v2.18h-.46V204.5h-.77v-.45h2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.75,204.05v2.63h-.45v-1.86l-.87,1.34-.86-1.34v1.86h-.46v-2.63h.5l.82,1.28.83-1.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.57,210.88v.85a5.82,5.82,0,0,0-1.5-.81,5.52,5.52,0,0,0-1.94-.32,5.76,5.76,0,0,0-2.26.44,5.57,5.57,0,0,0-1.8,1.2A5.43,5.43,0,0,0,79.89,214a5.82,5.82,0,0,0,0,4.34,5.39,5.39,0,0,0,3,3,5.76,5.76,0,0,0,2.26.44h.22a6.18,6.18,0,0,0,2.29-.43v-3h0a3.06,3.06,0,0,1-1,.66,3.36,3.36,0,0,1-1.23.23,4.55,4.55,0,0,1-.52,0h0a3.55,3.55,0,0,1-.71-.19,3,3,0,0,1-1-5,3,3,0,0,1,1-.66,3.2,3.2,0,0,1,1.23-.23,3.16,3.16,0,0,1,2.28.89,2.88,2.88,0,0,1,.94,2.16v5.57h2.67V210.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.23,221.77,71.3,216v5.73H68.62V206.68H71.3v5.71l5.93-5.68H81l-7.83,7.51L81,221.77Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.2,210.6a4.94,4.94,0,0,1,2,.4,4.62,4.62,0,0,1,1.53,1.08,4.93,4.93,0,0,1,1,1.6,5.38,5.38,0,0,1,.34,1.94v6.15h-2.67v-6.15a2.24,2.24,0,0,0-.78-1.75,2.71,2.71,0,0,0-3.68,0,2.3,2.3,0,0,0-.76,1.75v6.15H92.47V210.9h2.68v.81a5.24,5.24,0,0,1,1.36-.8A4.54,4.54,0,0,1,98.2,210.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.48,210.9a4.85,4.85,0,0,1,1.8-.32v2.54a3.19,3.19,0,0,0-2.28.9,3,3,0,0,0-.93,2.16v5.59h-2.68V210.88h2.68v.83A5.58,5.58,0,0,1,134.48,210.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.34,210.6a6,6,0,0,1,2.29.44,5.93,5.93,0,0,1,1.88,1.2,5.64,5.64,0,0,1,1.26,1.78,5.35,5.35,0,0,1,0,4.34,5.76,5.76,0,0,1-1.26,1.78,5.9,5.9,0,0,1-1.88,1.19,6.21,6.21,0,0,1-4.59,0,5.9,5.9,0,0,1-1.88-1.19,5.76,5.76,0,0,1-1.26-1.78,5.46,5.46,0,0,1,0-4.34,5.64,5.64,0,0,1,1.26-1.78A5.93,5.93,0,0,1,140,211,6,6,0,0,1,142.34,210.6Zm0,2.55a3.16,3.16,0,0,0-2.28.89,2.93,2.93,0,0,0,0,4.3,2.84,2.84,0,0,0,1,.66,3.41,3.41,0,0,0,1.24.23,3.31,3.31,0,0,0,1.22-.23,3.06,3.06,0,0,0,1.05-.66,2.93,2.93,0,0,0,0-4.3A3.24,3.24,0,0,0,142.34,213.15Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.86,210.6a6.08,6.08,0,0,1,2.3.44,5.88,5.88,0,0,1,1.87,1.2,5.34,5.34,0,0,1,1.26,1.78,5.35,5.35,0,0,1,0,4.34,5.45,5.45,0,0,1-1.26,1.78,5.85,5.85,0,0,1-1.87,1.19,6.23,6.23,0,0,1-4.6,0,6,6,0,0,1-1.87-1.19,5.45,5.45,0,0,1-1.26-1.78,5.35,5.35,0,0,1,0-4.34,5.34,5.34,0,0,1,1.26-1.78,6,6,0,0,1,1.87-1.2A6.08,6.08,0,0,1,154.86,210.6Zm0,2.55a3.14,3.14,0,0,0-2.27.89,2.93,2.93,0,0,0,0,4.3,2.8,2.8,0,0,0,1,.66,3.49,3.49,0,0,0,1.24.23,3.4,3.4,0,0,0,1.23-.23,3.25,3.25,0,0,0,1-.66,3,3,0,0,0,0-4.3A3.28,3.28,0,0,0,154.86,213.15Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.23,210.88v.85a5.75,5.75,0,0,0-1.49-.81,5.56,5.56,0,0,0-1.94-.32,5.85,5.85,0,0,0-2.27.44,5.42,5.42,0,0,0-1.79,1.2,5.28,5.28,0,0,0-1.18,1.78,5.69,5.69,0,0,0,0,4.34,5.41,5.41,0,0,0,3,3,5.85,5.85,0,0,0,2.27.44H123a6.22,6.22,0,0,0,2.29-.43v-3h0a3.25,3.25,0,0,1-1,.66,3.4,3.4,0,0,1-1.23.23,4.55,4.55,0,0,1-.52,0h0a3.83,3.83,0,0,1-.72-.19,2.8,2.8,0,0,1-1-.66,2.93,2.93,0,0,1,0-4.3,2.94,2.94,0,0,1,1-.66,3.29,3.29,0,0,1,1.24-.23,3.18,3.18,0,0,1,2.28.89,2.87,2.87,0,0,1,.93,2.16v5.57h2.68V210.88Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.26,210.88v.85a5.66,5.66,0,0,0-1.5-.81,4.65,4.65,0,0,0-1-.24,7,7,0,0,0-1.15-.1,5.53,5.53,0,0,0-2.22.44,5.23,5.23,0,0,0-1.74,1.19,5.51,5.51,0,0,0-1.13,1.78,5.88,5.88,0,0,0-.4,2.19h0a5.62,5.62,0,0,0,.42,2.16,5.39,5.39,0,0,0,3,3,5.8,5.8,0,0,0,2.26.44h.4a6.15,6.15,0,0,0,2.11-.42v-3h0a3.06,3.06,0,0,1-1,.66,3.31,3.31,0,0,1-1.22.23,4.38,4.38,0,0,1-.52,0h0a3.47,3.47,0,0,1-.72-.19,3.05,3.05,0,0,1-2-2.81,3,3,0,0,1,.21-1.13.36.36,0,0,0,0-.09,3,3,0,0,1,.68-.93,3,3,0,0,1,1-.66,3.25,3.25,0,0,1,1.24-.23,3.14,3.14,0,0,1,2.27.89,2.85,2.85,0,0,1,.68.93l0,.09a2.86,2.86,0,0,1,.22,1.14v4.23a2.82,2.82,0,0,1-.94,2.14,3.08,3.08,0,0,1-2.27.91,3.12,3.12,0,0,1-1.61-.42l-1.94,1.82a6.15,6.15,0,0,0,1.65.85,6,6,0,0,0,1.9.3,5.85,5.85,0,0,0,2.29-.45,6,6,0,0,0,1.88-1.21,5.64,5.64,0,0,0,1.26-1.78,5.23,5.23,0,0,0,.46-2.16v-9.55Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.73,231v.71H68.62v-4.05h3v.71H69.42v1h1.84v.69H69.42V231Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.87,227.3v4.34h-.81v-.19a1.8,1.8,0,0,1-.9.24,1.62,1.62,0,0,1,0-3.23,1.8,1.8,0,0,1,.9.24v-1.4Zm-.81,3.4v-1.26a1.18,1.18,0,0,0-.76-.26.9.9,0,1,0,0,1.79A1.19,1.19,0,0,0,76.06,230.7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82,228.52v3.12h-.8v-.2a1.47,1.47,0,0,1-.85.25c-.91,0-1.33-.43-1.33-1.44v-1.73h.8v1.73c0,.49.23.72.68.72a1,1,0,0,0,.7-.25v-2.2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M86.89,231.06a1.48,1.48,0,0,1-1.2.63,1.61,1.61,0,1,1,0-3.22,1.52,1.52,0,0,1,1.22.62l-.52.47a.86.86,0,0,0-.7-.38.9.9,0,1,0,0,1.79.86.86,0,0,0,.7-.38Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92,228.52v3.12h-.8v-.23a1.59,1.59,0,0,1-.92.28,1.62,1.62,0,0,1,0-3.23,1.82,1.82,0,0,1,.92.26v-.2Zm-.8.93a1.24,1.24,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.23,1.23,0,0,0,.77-.26Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M95.15,229.18v1.11c0,.56.09.72.49.72a3.7,3.7,0,0,0,.37,0v.6a2,2,0,0,1-.72.11.89.89,0,0,1-.94-1v-1.53H93.9v-.66h.45v-1.21h.8v1.21H96v.66Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.93,227.76a.47.47,0,0,1,.46-.47.47.47,0,0,1,.46.47.46.46,0,0,1-.46.47A.47.47,0,0,1,97.93,227.76Zm.07.81h.79v3.12H98Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.23,230.08a1.71,1.71,0,1,1-1.7-1.61A1.66,1.66,0,0,1,104.23,230.08Zm-.78,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,103.45,230.08Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109.21,230v1.74h-.8V230c0-.48-.23-.72-.68-.72a1,1,0,0,0-.69.25v2.21h-.79v-3.12H107v.19a1.46,1.46,0,0,1,.84-.25C108.79,228.51,109.21,228.94,109.21,230Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M115.48,228.35v1.44h1.94v.72h-1.94v1.18h-.8v-4.05h3.06v.71Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.9,230.08a1.71,1.71,0,1,1-1.71-1.61A1.66,1.66,0,0,1,122.9,230.08Zm-.79,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,122.11,230.08Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.86,228.52v3.12h-.8v-.2a1.49,1.49,0,0,1-.85.25c-.91,0-1.33-.43-1.33-1.44v-1.73h.8v1.73c0,.49.23.72.67.72a1,1,0,0,0,.71-.25v-2.2Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M133,230v1.74h-.8V230c0-.48-.24-.72-.68-.72a1,1,0,0,0-.69.25v2.21H130v-3.12h.8v.19a1.46,1.46,0,0,1,.84-.25C132.57,228.51,133,228.94,133,230Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M138.27,227.3v4.34h-.81v-.19a1.81,1.81,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.23,1.81,1.81,0,0,1,.91.24v-1.4Zm-.81,3.4v-1.26a1.18,1.18,0,0,0-.76-.26.9.9,0,1,0,0,1.79A1.19,1.19,0,0,0,137.46,230.7Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M143.56,228.52v3.12h-.8v-.23a1.59,1.59,0,0,1-.92.28,1.62,1.62,0,0,1,0-3.23,1.82,1.82,0,0,1,.92.26v-.2Zm-.8.93a1.26,1.26,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.23,1.23,0,0,0,.77-.26Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M146.69,229.18v1.11c0,.56.09.72.49.72a3.7,3.7,0,0,0,.37,0v.6a2.06,2.06,0,0,1-.72.11.9.9,0,0,1-1-1v-1.53h-.44v-.66h.44v-1.21h.81v1.21h.87v.66Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M149.47,227.76a.46.46,0,1,1,.92,0,.46.46,0,1,1-.92,0Zm.06.81h.8v3.12h-.8Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.77,230.08a1.71,1.71,0,1,1-1.71-1.61A1.66,1.66,0,0,1,155.77,230.08Zm-.79,0a.91.91,0,0,0-.92-.9.9.9,0,1,0,0,1.79A.9.9,0,0,0,155,230.08Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M160.75,230v1.74H160V230c0-.48-.23-.72-.68-.72a1,1,0,0,0-.69.25v2.21h-.8v-3.12h.8v.19a1.46,1.46,0,0,1,.84-.25C160.33,228.51,160.75,228.94,160.75,230Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 11.73,
    y1: 219.29,
    x2: 68.49,
    y2: 219.29
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6,222.07v-4.46l-.86.91-.4-.41,1.34-1.38h.58v5.34Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 5.92,
    cy: 219.29,
    r: 5.67
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 363.59,
    y1: 440.79,
    x2: 363.59,
    y2: 336.55
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.59,448.39,362,448a1.83,1.83,0,0,0,1.49.7c.77,0,1.24-.39,1.24-1s-.54-.94-1.32-.94h-.56v-.61h.56c.67,0,1.24-.26,1.24-.88s-.55-.91-1.2-.91a1.78,1.78,0,0,0-1.4.65l-.37-.42a2.29,2.29,0,0,1,1.83-.82c1,0,1.8.52,1.8,1.41a1.28,1.28,0,0,1-1.14,1.24,1.36,1.36,0,0,1,1.23,1.32c0,.89-.72,1.54-1.9,1.54A2.23,2.23,0,0,1,361.59,448.39Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 363.59,
    cy: 446.46,
    r: 5.67
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.81,8.63V8.09c1.92-1.5,3-2.39,3-3.31a1,1,0,0,0-1.12-1,1.76,1.76,0,0,0-1.44.67l-.41-.42a2.26,2.26,0,0,1,1.85-.84,1.62,1.62,0,0,1,1.79,1.56c0,1.09-1.1,2.08-2.59,3.26h2.62v.59Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 180.74,
    cy: 5.92,
    r: 5.67
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 179.14,
    y1: 112.93,
    x2: 179.14,
    y2: 11.26
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 182.31,
    y1: 11.26,
    x2: 182.31,
    y2: 277.82
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 68.63,
    y: 199.45,
    width: 92.13,
    height: 36.85
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 50.2,
    y: 33.62,
    width: 368.5,
    height: 368.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBvm1);
export default __webpack_public_path__ + "static/media/bvm1.06b1ce0efe3e8e3605c076b79ad2ff7d.svg";
export { ForwardRef as ReactComponent };